import { types } from 'mobx-state-tree';

const OrderMethod = types.model('OrderMethod', {
  id: types.maybeNull(types.number),
  logo: types.maybeNull(types.string),
  name: types.optional(types.string, ''),
});

export default OrderMethod;
